import {IFaq} from "./interfaces/IFaq";

export const emptyFaq: IFaq[] = [];
import {IFaq} from "./interfaces/IFaq";

export const emptyFaq: IFaq[] = [];
